<template>
  <v-dialog v-model="showDialog" persistent max-width="400">
    <v-card style="border-radius: 16px; position: relative">
      <v-card-title
        class="mb-0 pt-3 pa-2 py-3 mx-auto d-block font-weight-bold"
        style="
          width: 100%;
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        "
      >
        <div style="display: grid; text-align: center; width: 100%">
          <v-icon size="110" color="green">mdi-check-circle</v-icon>
          {{ $t("specialReward") }}
        </div>
      </v-card-title>
      <section
        class="d-flex flex-column px-3 mt-2 pa-3"
        style="
          max-height: 60vh;
          overflow-y: auto;
          margin-bottom: 0;
          overflow-x: hidden;
        "
      >
        <div style="margin-top: -12px">
          <div v-for="(item, index) in rewardItem" :key="index" class="pa-1">
            <section class="d-flex flex-column" style="width: 100%">
              <div
                class="d-flex align-center mb-2"
                style="
                  width: 100%;
                  border-radius: 5px;
                  height: 100px;
                  transition: background-color 0.2s ease-in-out;
                "
                :style="{
                  backgroundColor: isRewardSelected(item)
                    ? 'rgba(50, 50, 93, 0.10)'
                    : '',
                }"
              >
                <div
                  style="
                    width: 70px;
                    min-width: 70px;
                    height: 70px;
                    overflow: hidden;
                    border-radius: 5px;
                    margin-left: 12px;
                  "
                >
                  <PointSymbol
                    v-if="
                      type === 'welcomeReward' &&
                      item.type === 'point' &&
                      item.point_type_id
                    "
                    :type="item.point_type_type"
                    :symbol="item.point_type_symbol"
                    :color="item.point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="70"
                  />
                  <img
                    v-else
                    :src="item.image_path"
                    style="width: 100%; height: 100%; object-fit: cover"
                  />
                </div>
                <div
                  style="
                    height: 70px;
                    width: 100%;
                    position: relative;
                    min-width: 0;
                  "
                  class="pl-3 pr-3"
                >
                  <div
                    class="description-label-2"
                    style="font-size: 15px; font-weight: bold"
                  >
                    {{ item.name }}
                  </div>

                  <p
                    style="
                      position: absolute;
                      right: 8px;
                      bottom: 0px;
                      font-size: 10px;
                      margin-bottom: 0px;
                      font-weight: bold;
                    "
                  >
                    {{ getRedeem(item) }}
                  </p>
                </div>
              </div>
              <v-divider style="border-color: rgb(0 0 0 / 20%)"> </v-divider>
            </section>
          </div>
        </div>
      </section>

      <v-card-actions
        class="pb-5 d-flex flex-column"
        style="width: 100%; box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1)"
      >
        <div class="d-flex my-2" style="height: 15px" v-if="isLoading">
          <v-progress-circular indeterminate :color="site.color" size="16" />
          <p class="ml-3 font-italic" style="color: gray">
            {{ $t("waitingLoad") }}...
          </p>
        </div>

        <v-spacer></v-spacer>
        <v-btn
          :color="site.color"
          class="mt-2 rounded-lg white--text font-weight-bold"
          depressed
          @click="confirmReward()"
          style="width: 75%; color: white; height: 40px"
        >
          {{ $t("confirm") }}
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import PointSymbol from "./point/point-symbol.vue";

export default {
  components: { PointSymbol },
  name: "DialogRewardConfirm",
  emits: ["openDialogAddress", "confirm"],
  props: {
    showDialog: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "welcomeReward",
    },
    rewardItem: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    rewardSelect: [],
    totalGetReward: 0,
  }),
  methods: {
    getSelectReward() {
      this.rewardSelect = [...this.rewardItem];
    },
    getRedeem(item) {
      const formattedPoint = this.$options.filters.commaPoint(item.num || 1);
      return this.$t("textRewardCount", { count: formattedPoint });
    },

    isRewardSelected(item) {
      return this.rewardSelect.some(
        (selectedItem) => selectedItem.id === item.id
      );
    },
    openAddressDialog() {
      this.dialogAddressVisible = true;
      this.$emit("openDialogAddress");
    },

    defaultIdCardImage() {
      return require("@/assets/images/example-thai-id.jpg");
    },
    async confirmReward() {
      const data = {
        detail: this.detail,
        rewardSelect: this.rewardSelect,
      };

      this.$emit("confirm", data);
    },
  },
  watch: {
    rewardSelect() {
      if (this.type == "welcomeReward") {
        this.checkRewardSelect = false;
      }
    },
    showDialog() {
      if (this.showDialog) {
        this.getSelectReward();
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>